import React from 'react';
import { Colors, Text } from 'library';
import { IndeedChildrenProps } from '../IndeedModels';

const TandemFreeText = ({ children }: IndeedChildrenProps) => {
    return (
        <Text variant="body2" textStyle={{ marginRight: 10 }} color={Colors.darkGrey}>
            {children}
        </Text>
    );
};

export default TandemFreeText;
